const listForReplace = {
  gr8: 'Ultim8',
};

export { listForReplace };